import { Loadable } from '../Loadable';

export const AsyncDrinkDetail = Loadable(() => import('./DrinkDetail'));
export const AsyncMenu = Loadable(() => import('./Menu'));
